// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2895":"3b24c060b1ccd5ad","3302":"dbfbe48f9c4e6dad","3536":"472a893abcf8f94b","3983":"0dca746a167be46b","6339":"70bae5f6f329ab0f","7929":"2beee3da91c05189","8033":"38416752d7ec628c","8523":"0aa1c40267678cb9"}[chunkId] + ".css";
};